import { render } from "./ComeFunzionaMobile.vue?vue&type=template&id=161dcbdb&scoped=true"
import script from "./ComeFunzionaMobile.vue?vue&type=script&lang=js"
export * from "./ComeFunzionaMobile.vue?vue&type=script&lang=js"

import "./ComeFunzionaMobile.vue?vue&type=style&index=0&id=161dcbdb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161dcbdb"]])

export default __exports__